module.exports = "/src/views/player/documets/images/female.png";